module.exports = __webpack_public_path__ + "img/icon4.276dd6b5.png";